import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// QR Code 2 (extérieur pharmacie) — accès direct à l'annuaire Instapharm (urgences),
// sans bilan ni cabine. On conserve le pharmacySlug pour un usage multi-pharmacies futur.
export default function ServicesUrgences() {
  const navigate = useNavigate();
  const { pharmacySlug } = useParams();
  useEffect(() => {
    navigate(`/instapharm/centres?from=urgences&pharmacie=${encodeURIComponent(pharmacySlug || "")}`, { replace: true });
  }, [navigate, pharmacySlug]);
  return (
    <div className="min-h-screen grid place-items-center bg-background text-muted-foreground">
      <p data-testid="urgences-redirect">Redirection vers les services d'urgences…</p>
    </div>
  );
}
